export const gameAssets = {
  lavenderBackground: new URL("./raw/generated/bg-lavender-playroom.webp", import.meta.url).href,
  beanShopkeeper: new URL("./raw/generated/mascot-bean-shopkeeper.webp", import.meta.url).href,
  trayFrame: new URL("./raw/generated/tray-frame.webp", import.meta.url).href,
} as const;

export type GameAssetKey = keyof typeof gameAssets;
